import { useEffect, useState } from 'react';
import '../styles/GallerySection.css';

// IMÁGENES DEL CAROUSEL
const carouselImages = [
  require('../assets/galeria/gal1.png'),
  require('../assets/galeria/gal2.png'),
  require('../assets/galeria/gal3.png'),
  require('../assets/galeria/gal4.png'),
  require('../assets/galeria/gal5.png'),
  require('../assets/galeria/gal6.png'),
  require('../assets/galeria/gal7.png'),
];

// IMÁGENES DE LAS SECCIONES
const sectionImages = [
  require('../assets/resultados/res1.png'),
  require('../assets/resultados/res2.png'),
  require('../assets/resultados/res3.png'),
  require('../assets/resultados/res4.png'),
  require('../assets/resultados/res5.png'),
  require('../assets/resultados/res6.png'),
];

export default function GallerySection() {
  const [index, setIndex] = useState(0);

  // AUTOPLAY
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % carouselImages.length);
    }, 5500); // 2.5 segundos

    return () => clearInterval(interval);
  }, []);

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  };

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % carouselImages.length);
  };

  return (
    <section className="gallery-section">
      {/* HEADER */}
      <div className="gallery-header">
        <h2>RESULTADOS QUE GENERAN CONFIANZA</h2>
        <p>Una de las claves de nuestra forma de trabajar es actuar como si el cliente fuésemos nosotros. Al desarrollar nuestra actividad en distintas áreas del sector, tenemos claro cómo nos gusta presentar un inmueble y cómo deben abordarse las operaciones. Ese criterio es el que aplicamos cuando intervenimos en la venta de una vivienda. Incluso ante los problemas, no somos los mejores por no cometerlos, sino por cómo los resolvemos, acompañando y enfrentando las dificultades y soluciones desde la perspectiva de nuestros clientes.
        </p>
      </div>

      {/* PRIMER BLOQUE */}
      <div className="gallery-grid">
        <div className="gallery-item">
          <img src={sectionImages[0]} alt="SATISFACCIÓN" />
          <h3>SATISFACCIÓN</h3>
          <p>Perseguimos la satisfacción de todas las partes implicadas en cada operación, abordando con rigor y meticulosidad cada aspecto del proceso negociador. Afrontamos los posibles inconvenientes con eficiencia, constancia y un firme compromiso por alcanzar soluciones que aporten equilibrio y confianza.</p>
        </div>

        <div className="gallery-item">
          <img src={sectionImages[1]} alt="COMODIDAD" />
          <h3>COMODIDAD</h3>
          <p>Pon en nuestras manos la gestión necesaria para alcanzar la rentabilidad y la seguridad que buscas. Nos ocupamos de coordinar cada actuación requerida, permitiéndote delegar con confianza y sin preocupaciones. A través de una reunión previa, analizamos tu situación y definimos una estrategia personalizada, adaptada a tus necesidades y objetivos, para que cada paso se desarrolle con orden y seguridad.</p>
        </div>

        <div className="gallery-item">
          <img src={sectionImages[2]} alt="RENTABILIDAD" />
          <h3>RENTABILIDAD</h3>
          <p>Conocemos en profundidad el mercado y asesoramos en la toma de decisiones alineadas con objetivos a largo plazo. Analizamos cada operación para identificar la estrategia más adecuada según su perfil y potencial, optimizando su desarrollo para obtener el máximo rendimiento de forma sostenible.</p>
        </div>
      </div>

      {/* SEGUNDO BLOQUE */}
      <div className="gallery-grid">
        <div className="gallery-item">
          <img src={sectionImages[3]} alt="FISCALIDAD" />
          <h3>FISCALIDAD</h3>
          <p>Aportamos una visión clara y preventiva sobre los riesgos asociados a determinadas operaciones y organizamos los pasos necesarios para estructurarlas de manera legal y eficiente. Conscientes de que muchas decisiones fiscales dependen del enfoque elegido, ponemos a disposición de nuestros clientes el criterio de profesionales especializados, facilitando un conocimiento completo de las ventajas y posibles implicaciones de cada alternativa.</p>
        </div>

        <div className="gallery-item">
          <img src={sectionImages[4]} alt="WIN-WIN" />
          <h3>FINANCIACIÓN</h3>
          <p>Simplificamos la complejidad del proceso financiero coordinando todas las fases necesarias para que cada operación se desarrolle de forma clara, ordenada y fluida. Reducimos gestiones, plazos y fricciones innecesarias, apoyándonos en la asesoría hipotecaria para ofrecer, de manera gratuita, una visión completa y comparativa de las opciones disponibles entre las distintas entidades bancarias.</p>
        </div>

        <div className="gallery-item">
          <img src={sectionImages[5]} alt="VALOR" />
          <h3>VALOR</h3>
          <p>Nuestro objetivo es que, con el paso del tiempo, sientas que cada operación desarrollada con nosotros ha respondido a tus problemas mediante decisiones acertadas y activos bien gestionados. Trabajamos para que tus activos evolucionen de forma sólida y rindan de la mejor manera a lo largo de los años.</p>
        </div>
      </div>

      {/* CAROUSEL */}
      <div className="carousel">
        <button
          className="carousel-btn left"
          onClick={prevSlide}
          aria-label="Imagen anterior"
        >
          ‹
        </button>

        <div
          className="carousel-track"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {carouselImages.map((img, i) => (
            <img key={i} src={img} alt={`Galería ${i + 1}`} />
          ))}
        </div>

        <button
          className="carousel-btn right"
          onClick={nextSlide}
          aria-label="Imagen siguiente"
        >
          ›
        </button>
      </div>
    </section>
  );
}